import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { MessagesService } from '@core/_services/messages.service';

export const canActivateChildGuard = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const message = inject(MessagesService);

    const isAuthenticated = await auth.isAuthenticated();
    
    if (!isAuthenticated) {
        auth.clearStorage();
        router.navigate(['expired']);
        return false;
    } else {
        const urlCheck = await auth.checkUrl();
        if (!urlCheck) {
            console.log('canActivateChild notfound');       
            auth.clearStorage();
            router.navigate(['notfound']);
            return false;
        } else {
            message.setError(false);
            return true;
        }
    }
};

export const canActivateGuard = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const message = inject(MessagesService);
    const isAuthenticated = await auth.isAuthenticated();
    
    if (!isAuthenticated) {
        auth.clearStorage();
        router.navigate(['login']);
        return false;
    } else {
        message.setError(false);
        return await auth.checkUrl();
    }
};